import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import SectionHeader from "../../../components/SectionHeader";
import CreateMenuForm from "../../signups/components/CreateMenuForm";
import { timeConverter } from "../../../utils/timeConverter";
import CountInfo from "../../signups/components/CountInfo";
import { GET_DISHES_SINCE_THREE_WEEKS_AGO } from "../gql/queries";

const UpcomingDishList = () => {
    const [expandedMenuId, setExpandedMenuId] = useState(null);
    const [dishesSinceThreeWeeksAgo, setDishesSinceThreeWeeksAgo] = useState([]);

    const { loading: dishesLoading, data: dishData } = useQuery(GET_DISHES_SINCE_THREE_WEEKS_AGO);
    let dishesData = dishData?.dishesSinceThreeWeeksAgo || [];

    useEffect(() => {
        if (!dishesLoading) {
            setDishesSinceThreeWeeksAgo(dishesData);
        }
    }, [dishesLoading, dishesData]);

    return (
        <div className="mainContainer">
            <CreateMenuForm dishesSinceThreeWeeksAgo={dishesSinceThreeWeeksAgo} setDishesSinceThreeWeeksAgo={setDishesSinceThreeWeeksAgo} />
            <SectionHeader title="Upcoming Dishes" className='sectionHeader' />
            <div className="dishContainer">
                {dishesSinceThreeWeeksAgo && dishesSinceThreeWeeksAgo.map(menu => (
                    <div key={menu._id}>
                        <div className="weeklyDishContainer">
                            <div id="upcomingDishesRow" className="dishesRow">
                                <p>{menu.dish?.dishName}</p>
                                <p>{timeConverter(menu.menuDate)}</p>
                                <p>{menu.cook?.fullName}</p>
                                <CountInfo 
                                    menu={menu} 
                                    showAll={true}
                                    isExpanded={expandedMenuId === menu._id}
                                    onExpand={() => setExpandedMenuId(menu._id)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default UpcomingDishList;
